export const FIELDS = {
  ID: 'id',
  COMPANY_ID: 'companyId',
  COMPANY_NAME: 'companyName',
  SOURCE_ID: 'sourceId',
  SOURCE_NAME: 'sourceName',
  REFERENCE_ID: 'referenceId',
  RMAID: 'rmaId',
  VENDOR_RMAID: 'vendorRmaId',
  INVOICE_ID: 'invoiceId',
  SERVICE_ORDER_ID: 'serviceOrderId',
  PAYMENT_ID: 'paymentId',
  BILL_PAYMENT_ID: 'billPaymentId',
  PAYMENT_METHOD_ID: 'paymentMethodId',
  REFERENCE_NUMBER: 'referenceNumber',
  PAYMENT_DATE: 'paymentDate',
  PAYMENT_METHOD_NAME: 'paymentMethodName',
  AMOUNT: 'amount',
  APPLIED: 'applied',
  BALANCE: 'balance',
  IS_PENDING: 'isPending',
  IS_REFUND: 'isRefund',
  IS_CLOSED_REFUND: 'isClosedRefund',
  REFUND_FROM_ACCOUNT: 'refundFromAccount',
  QBREFUND_ACCOUNT_ID: 'qbRefundAccountId',
  COMMENT: 'comment',
  SALES_ORDER_ID: 'salesOrderId',
  SODATE: 'soDate',
  CUSTOMER_PO: 'customerPo',
  PURCHASE_ORDER_ID: 'purchaseOrderId',
  PODATE: 'poDate',
  QBSYNCED: 'qbSynced',
  QBTXN_ID: 'qbTxnId',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  ACTIVE: 'active',};